import { combineReducers } from 'redux';

import categories from './categories';
import products from './products';
import product from './product';
import breadcrumb from './breadcrumb';
import filter from './filter';


export default combineReducers({
  categories,
  products,
  product,
  breadcrumb,
  filter,
});
